<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">{{
          $t('administration.personneMorale.contextes.list.title')
        }}</v-list-item-title>
        <v-list-item-subtitle>{{
          $t('administration.personneMorale.contextes.list.sub')
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="4">
          <search-by
            :datasource="dsContexte"
            attr="libelle"
            i18n="administration.personneMorale.contextes.list.search.libelle"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <search-by
            :datasource="dsContexte"
            attr="description"
            i18n="administration.personneMorale.contextes.list.search.description"
          />
        </v-col>
        <v-col>
          <v-btn
            :to="{ name: 'administration/personneMorale/contexte-new' }"
            color="primary"
            >{{ $t('button.new') }}</v-btn
          >
        </v-col>
      </v-row>
      <datasource-table :datasource="dsContexte">
        <template #item.libelle="{item}">
          <navigable-link
            :to="{
              name: 'administration/personneMorale/contexte-detail',
              params: { id: item.id },
            }"
          >
            {{ item.libelle }}
          </navigable-link>
        </template>
        <template #item.description="{item}">
          {{ item.description }}
        </template>
      </datasource-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';

export default {
  mounted() {
    this.dsContexte.refresh();
  },
  props: {
    /** Titre de la page */
    title: {
      type: String,
      default: null,
    },
    /** Les infos pour le retour vers le menu paramétrage */
    returnRoute: {},
  },
  data() {
    const dsContexte = new Datasource('administration/contextes/contextes', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['libelle'],
      descending: false,
      labelNamespace: 'administration.personneMorale.contextes.list.table',
      args: {},
      fields: [
        {
          value: 'libelle',
          sortable: true,
        },
        {
          value: 'description',
          sortable: true,
        },
      ],
    });

    return {
      dsContexte,
    };
  },
  methods: {},
};
</script>
